// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-width[data-v-0535d112] {\n  max-width: 208px;\n}\n.disabled-box[data-v-0535d112] {\n  margin-bottom: 4px;\n}\n.disabled-box[data-v-0535d112] .el-checkbox__inner {\n  border-color: #DCDFE6;\n}\n.checkbox-group[data-v-0535d112] {\n  font-size: 0;\n  display: inline-block;\n  line-height: 1;\n  vertical-align: middle;\n}\n.checkbox-group[data-v-0535d112] .el-checkbox {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}", ""]);
// Exports
module.exports = exports;
